import Vue from 'vue'
import App from './App.vue'
import Vuelidate from 'vuelidate'
import router from './router/router.js'
import VueNotification from '@kugatsu/vuenotification'
import VModal from 'vue-js-modal'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSocialauth from 'vue-social-auth'
import store from "./store";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import AppBreadcrumb from '@/components/common/AppBreadcrumb.vue';
import JobCard from '@/components/common/JobCard.vue';
import JobCardSkeleton from '@/components/common/JobCardSkeleton.vue';
import AppDownloadBanner from '@/components/common/AppDownloadBanner.vue';
import CustomSelect from '@/components/common/CustomSelect.vue';
import PasswordInput from '@/components/common/PasswordInput.vue';
import JobDetailContent from '@/components/common/JobDetailContent.vue';
import ResumeDetailContent from '@/components/common/ResumeDetailContent.vue';
import AppIcon from '@/components/common/AppIcon.vue';

Vue.component('AppBreadcrumb', AppBreadcrumb);
Vue.component('JobCard', JobCard);
Vue.component('JobCardSkeleton', JobCardSkeleton);
Vue.component('AppDownloadBanner', AppDownloadBanner);
Vue.component('CustomSelect', CustomSelect);
Vue.component('PasswordInput', PasswordInput);
Vue.component('JobDetailContent', JobDetailContent);
Vue.component('ResumeDetailContent', ResumeDetailContent);
Vue.component('AppIcon', AppIcon);
Vue.use(Vuelidate);
Vue.use(VueAxios, axios);
Vue.prototype.$store = store;
Vue.use(VueSocialauth, {
    providers: {
        facebook: {
            clientId: process.env.VUE_APP_CLIENTID,
            redirectUri: process.env.VUE_APP_REDIRECT_URL
        }
    }
});

Vue.use(VueNotification, {
    success: {
        background: "green",
        color: "white"
    },
    warning: {
        background: "#0284c7",
        color: "white"
    }
});

Vue.use(Loading, {
    color: '#04ba05'
  });


Vue.use(VModal, {
    dialog: true
});

function sanitizeData(data) {
    if (typeof data === 'string') {
        return data.normalize('NFKC');
    } else if (Array.isArray(data)) {
        return data.map(sanitizeData);
    } else if (data !== null && typeof data === 'object' && !(data instanceof File) && !(data instanceof Blob)) {
        const sanitized = {};
        for (const key in data) {
            sanitized[key] = sanitizeData(data[key]);
        }
        return sanitized;
    }
    return data;
}

axios.interceptors.request.use(
    config => {
        if (config.data) {
            if (config.data instanceof FormData) {
                const sanitized = new FormData();
                for (const [key, value] of config.data.entries()) {
                    if (typeof value === 'string') {
                        sanitized.append(key, value.normalize('NFKC'));
                    } else {
                        sanitized.append(key, value);
                    }
                }
                config.data = sanitized;
            } else {
                config.data = sanitizeData(config.data);
            }
        }
        if (config.params) {
            config.params = sanitizeData(config.params);
        }
        return config;
    },
    error => Promise.reject(error)
);

new Vue({
    router,
    store,
    render: h => h(App),
    /**
     * This is to set token to any request to server side.
     * @returns Resquest with configurations
     */
    // created() {
    //     axios.interceptors.request.use(
    //         function (config) {
    //             if (store.state.user) {
    //                 const token = store.state.user.token;
    //                 if (token) config.headers.Authorization = `${token}`;
    //             }
    //             return config;
    //         },
    //         function (error) {
    //             return Promise.reject(error);
    //         }
    //     );
    // },
}).$mount('#app')
